import { Component } from "@angular/core";

@Component({
    selector: 'mentions-legales',
    templateUrl: './mentions-legales.component.html',
    styleUrls: ['./mentions-legales.component.scss']
})
export class MentionsLegalesComponent{}